
export enum ApiTypes {
  PublicApi = 'public-web-api',
  AnalyticsApi = 'analytics-api',
}